module.exports = __webpack_public_path__ + "static/media/selfDefenseImg.d85ecaa9.png";